import { LoadingSpinnerIcon } from '@/assets/icons/LoadingSpinner';

export function LoadingComponent() {
  return (
    <div className='flex flex-col items-center justify-center space-y-8 px-4 py-10'>
      <LoadingSpinnerIcon className='size-16 text-gray-700' />
      <div className='text-center'>
        <p className='sh-heading-3'>Loading...</p>
        <p className='sh-body'>Please do not close this window</p>
      </div>
    </div>
  );
}
